// Idle (sliding) session configuration — Foundation PRD v0.3 US-F01,
// Sean 2026-06-03.
//
// SINGLE SOURCE OF TRUTH for the frontend idle window. Must agree with the
// backend env var SESSION_IDLE_MINUTES (default 60) in
// functions/auth-service/utils/sessionCookie.js. If the operator tunes the
// backend window, update SESSION_IDLE_MINUTES here to match so the frontend
// logs the user out at the same time the cookie/JWT expires.
//
// Activity (mousemove / keydown / click / scroll / touchstart) resets the
// idle timer. While the user is active, IdleSessionManager pings
// POST /auth/refresh on a throttled cadence so the backend window slides
// forward — an active user is NEVER logged out mid-task. After
// SESSION_IDLE_MINUTES of true inactivity the frontend forces a logout and
// the backend token has expired anyway, so the next request 401s.

export const SESSION_IDLE_MINUTES = 60;

export const SESSION_IDLE_MS = SESSION_IDLE_MINUTES * 60 * 1000;

// How often (at most) we ping /auth/refresh while the user is active. We only
// ping when there has been activity since the last ping — NOT on every
// request — so the backend Set-Cookie isn't hammered. 5 min is comfortably
// shorter than the 60-min window, so an active user's cookie always slides
// forward well before it would expire.
export const SESSION_REFRESH_INTERVAL_MS = 5 * 60 * 1000;

// Query param the idle logout appends to /login so the page can show the
// "signed out due to inactivity" message.
export const IDLE_LOGOUT_REASON = 'idle';
